import { locale, t } from '@app/i18n';
import type { AccessMap } from './AccessMap.api';

/**
 * O FRESCOR DO MAPA GUARDADO (mapa-acesso, 04/10).
 *
 * O mapa deixou de ser calculado a cada abertura: o servidor guarda a foto e a
 * recalcula quando algo que o mapa lê muda. A tela diz de quando é o que ela mostra
 * («calculado às 14:32») e se há mudança ainda não calculada («Atualizando: houve
 * mudança às 14:35»). Textos do protótipo aprovado pelo mrolim em 04/10.
 */

/**
 * Quanto a tela espera entre duas leituras enquanto há mudança pendente. Só
 * enquanto há: com o mapa em dia, nada se repete.
 */
export const PENDING_REFETCH_MS = 2000;

/**
 * `2026-10-04T14:32:00Z` → `14:32`, na hora local e no idioma ativo. Sem segundos:
 * a pergunta é «isto é de agora há pouco ou de antes da minha mudança?», e o minuto
 * responde.
 */
export function clockTime(iso: string): string {
  const instant = new Date(iso);
  if (Number.isNaN(instant.getTime())) return iso;
  return instant.toLocaleTimeString(locale(), { hour: '2-digit', minute: '2-digit' });
}

/**
 * A parte «calculado às HH:MM» da linha do cabeçalho. Com «claims avulsas» o mapa é
 * calculado na hora — não há foto —, e a linha diz isso.
 */
export function computedLabel(mapping: AccessMap): string {
  if (mapping.lens.kind === 'claims') return t('accessMap.meta.computedNow');
  return t('accessMap.meta.computedAt', { time: clockTime(mapping.computed_at) });
}

/** O texto do chip quando há mudança ainda não calculada; nulo quando o mapa está em dia. */
export function pendingLabel(mapping?: AccessMap): string | null {
  if (!mapping?.pending_since) return null;
  return t('accessMap.graph.pendingSince', { time: clockTime(mapping.pending_since) });
}
